import { cn } from "../../../lib/cn";

/**
 * ToggleGroup — segmented control (ej. Tabla / Kanban).
 *
 * Borde único, botones internos sin borde, activo con `#003c66`
 * y texto blanco.
 *
 * Uso:
 *   <ToggleGroup>
 *     <ToggleGroupItem active={vista === 'tabla'} onClick={...}>Tabla</ToggleGroupItem>
 *     <ToggleGroupItem active={vista === 'kanban'} onClick={...}>Kanban</ToggleGroupItem>
 *   </ToggleGroup>
 */

export function ToggleGroup({ children, className }) {
  return (
    <div className={cn(
      "inline-flex items-center rounded-md border border-border overflow-hidden",
      className,
    )}>
      {children}
    </div>
  );
}

export function ToggleGroupItem({ active, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "px-3 py-1.5 text-xs font-medium transition-colors",
        active
          ? "bg-primary text-white"
          : "bg-white text-slate-600 hover:bg-slate-50",
      )}
    >
      {children}
    </button>
  );
}
